import { mapActions, mapGetters } from "vuex";

export const robMixin = {
  computed: {
    ...mapGetters({
      rob: "rob/show/retrieved",
      robIsLoading: "rob/show/isLoading",

      robs: "rob/list/items",
      robsIsLoading: "rob/list/isLoading",
      robUpdateIsLoading: "rob/update/isLoading",
    }),
  },
  methods: {
    ...mapActions({
      getRob: "rob/show/retrieve",
      updateRob: "rob/update/update",
      getRobs: "rob/list/getItems",
    }),
  },
};
